
export const style: any = {
  theme: {
    logo: {
      height: '40px'
    }
  }
}